import Vue from 'vue'
import Vuex from 'vuex'
import ModuleMeu from "./meu.js";
Vue.use(Vuex)
import createPersistedstate from "vuex-persistedstate";

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    ModuleMeu,
  },
  plugins: [
    createPersistedstate({
      key: "xStore",
      storage:window.sessionStorage
    }),
  ],
})
